(function () {
  var AUTO_CLOSE_MS = 10000;
  var AUTO_CLOSE_REDUCED_MS = 20000;

  function getAutoCloseDelay() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ? AUTO_CLOSE_REDUCED_MS
      : AUTO_CLOSE_MS;
  }

  function initFaqChat(root) {
    if (!root || root.dataset.faqChatBound === 'true') return;
    root.dataset.faqChatBound = 'true';

    var dataEl = root.querySelector('[data-faq-chat-data]');
    var thread = root.querySelector('[data-faq-chat-thread]');
    var chips = root.querySelector('[data-faq-chat-chips]');
    var overflow = root.querySelector('[data-faq-chat-overflow]');
    if (!dataEl || !thread || !chips) return;

    var payload;
    try {
      payload = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var items = payload.items || [];
    var asked = new Set();

    function appendMessage(role, html, label) {
      var row = document.createElement('div');
      row.className = 'canicule-faq-chat__message canicule-faq-chat__message--' + role;
      row.setAttribute('role', 'article');
      row.setAttribute('aria-label', label || (role === 'user' ? 'Votre question' : 'Réponse FAQ'));

      var bubble = document.createElement('div');
      bubble.className = 'canicule-faq-chat__bubble rte';
      if (role === 'user') {
        bubble.textContent = html;
      } else {
        bubble.innerHTML = html;
      }

      row.appendChild(bubble);
      thread.appendChild(row);

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reducedMotion) {
        row.style.opacity = '0';
        row.style.transform = 'translateY(6px)';
        requestAnimationFrame(function () {
          row.style.transition = 'opacity 0.2s ease, transform 0.2s ease';
          row.style.opacity = '1';
          row.style.transform = 'translateY(0)';
        });
      }

      thread.scrollTop = thread.scrollHeight;
    }

    function showAnswer(item) {
      if (asked.has(item.id)) return;
      asked.add(item.id);
      appendMessage('user', item.question, 'Question : ' + item.question);
      appendMessage('faq', item.answerHtml, 'Réponse FAQ');
      var chip = chips.querySelector('[data-faq-id="' + item.id + '"]');
      if (chip) {
        chip.setAttribute('aria-pressed', 'true');
        chip.disabled = true;
        chip.classList.add('is-answered');
      }
    }

    items.forEach(function (item) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'canicule-faq-chat__chip';
      chip.textContent = item.chip;
      chip.setAttribute('data-faq-id', item.id);
      chip.setAttribute('aria-pressed', 'false');
      chip.addEventListener('click', function () {
        showAnswer(item);
      });
      chips.appendChild(chip);
    });

    var overflowChip = document.createElement('button');
    overflowChip.type = 'button';
    overflowChip.className = 'canicule-faq-chat__chip canicule-faq-chat__chip--overflow';
    overflowChip.textContent = payload.overflowChip || "Ma question n'est pas listée";
    overflowChip.addEventListener('click', function () {
      if (root.dataset.faqChatMode === 'widget') {
        var faqUrl = root.querySelector('.canicule-help-widget__full-faq a');
        if (faqUrl && faqUrl.href) {
          window.location.href = faqUrl.href;
          return;
        }
      }
      appendMessage(
        'faq',
        '<p>Pour une question personnalisée, utilisez le formulaire ci-dessous. Nous vous répondons par e-mail, pas de chat en direct.</p>',
        'Réponse FAQ'
      );
      if (overflow) {
        overflow.hidden = false;
        overflow.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        var emailInput = overflow.querySelector('input[type="email"]');
        if (emailInput) emailInput.focus();
      }
    });
    chips.appendChild(overflowChip);
  }

  function initHelpWidget() {
    var widget = document.querySelector('[data-canicule-help-widget]');
    if (!widget || widget.dataset.helpWidgetBound === 'true') return;
    widget.dataset.helpWidgetBound = 'true';

    var toggle = widget.querySelector('[data-help-widget-toggle]');
    var panel = widget.querySelector('[data-help-widget-panel]');
    var closeBtn = widget.querySelector('[data-help-widget-close]');
    if (!toggle || !panel) return;

    var autoCloseTimer = null;

    function clearAutoClose() {
      if (autoCloseTimer) {
        clearTimeout(autoCloseTimer);
        autoCloseTimer = null;
      }
    }

    function scheduleAutoClose() {
      clearAutoClose();
      autoCloseTimer = setTimeout(function () {
        if (!panel.hidden) {
          setOpen(false);
        }
      }, getAutoCloseDelay());
    }

    function setOpen(open) {
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        scheduleAutoClose();
      } else {
        clearAutoClose();
      }
    }

    toggle.addEventListener('click', function () {
      setOpen(panel.hidden);
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        setOpen(false);
      });
    }

    panel.addEventListener('click', function () {
      scheduleAutoClose();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !panel.hidden) {
        setOpen(false);
      }
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-canicule-faq-chat]').forEach(initFaqChat);
    initHelpWidget();
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    boot(document);
  });
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
